module.exports = __webpack_public_path__ + "media/images/expert__kaisa-maekaeraeinen-b5d2eb22ead771be6fc8195b3386a23c.png";